import React, {Fragment, useEffect} from 'react'
import {Grow, Typography} from '@material-ui/core'

const Finish = () => {
  useEffect(() => {
    const { localStorage } = window
    localStorage.clear()
  }, [])
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <div>
          <Typography
            component="h5"
            variant="h5"
            gutterBottom
            color="textPrimary">
            Processo finalizado
          </Typography>
          <Typography
            component="p"
            variant="body1"
            gutterBottom
            color="textPrimary">
            Pronto agora é só aguardar a análise dos documentos.
          </Typography>
        </div>
      </Grow>
    </Fragment>
  )
}

export default Finish
